import { styled } from '@zenbusiness/zui/styles';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

const DatePickerStyles = () => ({
  '& .MuiFormLabel-root.Mui-error': {
    color: 'rgba(0, 0, 0, 0.6)'
  }
});

export const DesktopDatePickerStyled = styled(DesktopDatePicker)(DatePickerStyles);
export const MobileDatePickerStyled = styled(MobileDatePicker)(DatePickerStyles);
